import React from "react";
import { motion } from "framer-motion";
import { Shield, Clock, Award, HeartHandshake } from "lucide-react";

const PILLARS = [
  {
    icon: Shield,
    title: "Qualité certifiée",
    desc: "Matériaux haut de gamme et finitions premium sur tous nos chantiers. Conformité aux normes sénégalaises et internationales.",
    color: "bg-[#1E3A8A]",
  },
  {
    icon: Clock,
    title: "Délais respectés",
    desc: "Livraison dans les temps grâce à notre rigueur de planification et notre équipe expérimentée présente sur le terrain.",
    color: "bg-[#E91E63]",
  },
  {
    icon: Award,
    title: "Garantie 10 ans",
    desc: "Garantie décennale sur la structure et garanties spécifiques sur les équipements. Votre tranquillité est notre priorité.",
    color: "bg-[#2D7A3F]",
  },
  {
    icon: HeartHandshake,
    title: "Accompagnement total",
    desc: "Du choix du terrain au suivi après livraison, notre équipe vous accompagne à chaque étape de votre projet.",
    color: "bg-[#0F1A3D]",
  },
];

export default function WhyTpco() {
  return (
    <section className="bg-white py-20 lg:py-24" data-testid="why-tpco">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mb-14"
        >
          <div className="text-[12px] text-[#E91E63] font-bold tracking-[0.3em] mb-3">// POURQUOI NOUS CHOISIR</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold leading-[1.1] tracking-tight text-[#0F1A3D]" style={{ fontFamily: "'Playfair Display', serif" }}>
            4 raisons de nous faire<br /><span className="text-[#1E3A8A]">confiance</span>.
          </h2>
          <p className="text-[15px] text-[#4B5775] mt-5 leading-relaxed max-w-2xl">
            Depuis plus de 12 ans, TPCO Sénégal construit la confiance avec ses clients en s'engageant sur des résultats concrets, mesurables, et durables.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group bg-white border border-[#E2E5F1] hover:border-[#1E3A8A] rounded-xl p-6 lg:p-7 transition hover-lift"
                data-testid={`pillar-${i}`}
              >
                <div className={`w-12 h-12 rounded-lg ${p.color} text-white flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-6 h-6" strokeWidth={1.7} />
                </div>
                <h3 className="font-display text-xl font-extrabold text-[#0F1A3D] tracking-tight leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {p.title}
                </h3>
                <p className="text-sm text-[#4B5775] leading-relaxed mt-3">{p.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
